<template>
  <div class="page">
    <navigation class="nav">活动规则</navigation>
    <div class="container">
      <div class="content">
        <div class="section">
          <div class="title">活动时间：{{ new Date() | formateDate('YYYY年MM月DD日') }}</div>
        </div>
        <div class="section">
          <div class="title">活动对象</div>
          <div class="desc">天美贷平台指定优质用户</div>
        </div>
        <div class="section">
          <div class="title">活动方式</div>
          <div class="desc">1、 活动期间，活动用户参与免费抽取提现插队卡。抽取成功后，即可前往「我要提现」页面提交提现申请，即可提前锁定优质高通资方</div>
          <div class="desc">2、 资方额度在领取提现插队卡后，指定时间内发起提现可享受高通过率资方专属资金，高通资方比普通资方放款通过率提升20%</div>
        </div>
        <div class="section">
          <div class="title">领取使用方式</div>
          <div class="desc">活动期间，通过首页活动入口进入活动详情页抽取提现插队卡，领取成功后，前往我要提现页面进行使用，指定时间内平台将自动为您分配高通过率资方。</div>
        </div>
      </div>
      <div class="footer">活动所有解释权归天美贷所有</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActOneRules',
  mounted () {
    // todo: 活动时间取值？
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page {
  background: linear-gradient( 270deg, #421636 0%, #2A1B44 100%);
  width: 100%;
  min-height: 100vh;
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 40px;
    .content {
      width: 670px;
      height: 1240px;
      border-radius: 30px;
      background-color: white;
      padding: 60px 30px;
      .section {
        margin-bottom: 60px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #333333;
          line-height: 45px;
        }
        .desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          line-height: 37px;
        }
      }
    }
    .footer {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #999999;
      line-height: 33px;
      margin-top: 50px;
    }
  }
}
</style>